import { render, staticRenderFns } from "./TerminalPaymentView.vue?vue&type=template&id=2e4b3985&scoped=true&"
import script from "./TerminalPaymentView.vue?vue&type=script&lang=js&"
export * from "./TerminalPaymentView.vue?vue&type=script&lang=js&"
import style0 from "./TerminalPaymentView.vue?vue&type=style&index=0&id=2e4b3985&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4b3985",
  null
  
)

export default component.exports